/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type { UnbuttonToken, UnbuttonTokenInterface } from "../UnbuttonToken";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "INITIAL_DEPOSIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOfUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "burnAll",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "burnAllTo",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burnTo",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "uAmount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "uAmount",
        type: "uint256",
      },
    ],
    name: "depositFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "underlying_",
        type: "address",
      },
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "initialRate",
        type: "uint256",
      },
    ],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mintFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "underlying",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "uAmount",
        type: "uint256",
      },
    ],
    name: "underlyingToWrapper",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "uAmount",
        type: "uint256",
      },
    ],
    name: "withdraw",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "withdrawAll",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
    ],
    name: "withdrawAllTo",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "uAmount",
        type: "uint256",
      },
    ],
    name: "withdrawTo",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "wrapperToUnderlying",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type UnbuttonTokenConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: UnbuttonTokenConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class UnbuttonToken__factory extends ContractFactory {
  constructor(...args: UnbuttonTokenConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<UnbuttonToken> {
    return super.deploy(overrides || {}) as Promise<UnbuttonToken>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): UnbuttonToken {
    return super.attach(address) as UnbuttonToken;
  }
  override connect(signer: Signer): UnbuttonToken__factory {
    return super.connect(signer) as UnbuttonToken__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): UnbuttonTokenInterface {
    return new utils.Interface(_abi) as UnbuttonTokenInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): UnbuttonToken {
    return new Contract(address, _abi, signerOrProvider) as UnbuttonToken;
  }
}
